import React, { createContext, useContext } from 'react';
import useReducerHook from 'src/hooks/reducer.hook';
import SensitiveCitiesReducer, {
    defaultState, asyncActions,
} from 'src/ducks/sensitive-cities.duck';

// We need to do this, to be able to get the typings of the Reducer
const useReducer = () => {
    return useReducerHook(SensitiveCitiesReducer, defaultState, asyncActions);
};

type IFSensitiveCitiesContext = ReturnType<typeof useReducer>;

// Having trouble setting initial values, that's why it is cast to the return type of the reducer
const SensitiveCitiesContext = createContext<Partial<IFSensitiveCitiesContext>>({
    state: defaultState,
}) as React.Context<IFSensitiveCitiesContext>;

const SensitiveCitiesProvider: React.FC = ({ children }) => {
    const reducer = useReducer();

    return (
        <SensitiveCitiesContext.Provider value={{ ...reducer }}>
            {children}
        </SensitiveCitiesContext.Provider>
    );
};

// We create context hook here so that we can able to unit test
// container components that uses this context
export const useSensitiveCitiesContext = () => useContext(SensitiveCitiesContext);

export type IuseSensitiveCitiesContext = ReturnType<typeof useSensitiveCitiesContext>;

export { SensitiveCitiesContext, SensitiveCitiesProvider };
